import React from 'react'
import { MyRouter } from './components/MyRouter.jsx'

function App() {
    return ( <
        MyRouter / >
    );
}

export default App;